import React, { useRef, useState } from 'react'
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import EmailIcon from '@mui/icons-material/Email';
import { TextField, colors } from '@mui/material';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { styled } from '@mui/system';
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast';
import "./contact.css"
function Contact() {
  const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
  };

  const grey = {
    50: '#f6f8fa',
    100: '#eaeef2',
    200: '#d0d7de',
    300: '#afb8c1',
    400: '#8c959f',
    500: '#6e7781',
    600: '#57606a',
    700: '#424a53',
    800: '#32383f',
    900: '#24292f',
  };

  const StyledTextarea = styled(TextareaAutosize)(
    ({ theme }) => `
    inline-size: 320px;
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 12px;
    border-radius: 12px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[500] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
  );

  // Form submit start
  const nameRef = useRef()
  const messageRef = useRef()
  const phoneRef = useRef()

  const [phone, setPhone] = useState("+998");

  const TOKEN = "6141775575:AAGfivBfpIHUfofup4X1-fHdxXAqh0yml1o"
  const CHAT_ID = "-1001959720174"
  const URL_API = `https://api.telegram.org/bot${TOKEN}/sendMessage`

  const handleSendDoc = (evt) => {
    evt.preventDefault()

    let message = `<b>Saytdan ariza !</b>\n`
    message += `<b>Ism : </b> ${evt.target.elements[0].value}\n`
    message += `<b>Telefon raqam : </b> ${evt.target.elements[3].value}\n`
    message += `<b>Habar : </b> ${messageRef.current.value}\n`

    axios.post(URL_API, {
      chat_id: CHAT_ID,
      parse_mode: 'html',
      text: message
    }).then(res => {
      toast.success("Данные получены")
      evt.target.elements[0].value = ""
      evt.target.elements[3].value = ""
      evt.target.elements[6].value = ""
      messageRef.current.value = ""
      setPhone("+998")
    }).catch(err => {
      toast.error("Ошибка")
    })
  }
  // Form submit end

  return (
    <section id='contact' className='bg-[#2F2C3D] py-10 sm:py-20'>
      <Toaster position="top-center" reverseOrder={false} />
      <div className='container mx-auto px-5'>
        <div className='max-w-[1110px]  text-center  mx-auto'>
          <h2 className='text-[30px] sm:text-[40px] font-bold text-white mb-2'>КОНТАКТЫ</h2>
          <p className='text-white text-[13px] mb-5 sm:text-[18px]'>Не стесняйтесь позвонить нам или просто используйте контактную форму ниже
            Республика Узбекистан, г.Ташкент, Яккасарайский район, улица Бабура, дом 69/4
            <a className='inline-block ml-5' href='tel:+998712009096'><PhoneEnabledIcon className='inline-block text-[#00C9DB]' /> <span className='inline-block align-middle'> +998 71 200 90 96</span></a>
            <a className='inline-block ml-5' href='mailto:info@cashbox.uz'><EmailIcon className='inline-block text-[#00C9DB]' /> <span className='inline-block align-middle'> info@cashbox.uz</span></a>
          </p>
        </div>
        <div className='flex flex-col md:flex-row items-center md:items-start space-y-10 md:space-y-0 mt-10 justify-center md:space-x-20'>
          <iframe title='Location' data-aos="fade-down" className='rounded-md w-full md:w-[600px]' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1498.982340543853!2d69.26070649111738!3d41.28787313458078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8bb2ac239901%3A0x61c0666992e246b5!2sCashbox.uz!5e0!3m2!1sru!2s!4v1686310978424!5m2!1sru!2s" width="600" height="340" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          <form onSubmit={handleSendDoc} data-aos="zoom-in-up" className='flex w-full sm:w-auto flex-col space-y-5'>
            <label className='w-full sm:w-[400px]'>
              <TextField
                required
                ref={nameRef}
                className='w-full'
                id="outlined-textarea"
                label="Фиo"
                placeholder="Фиo"
                multiline
              />
            </label>
            <label className='w-full sm:w-[400px]'>
              <TextField
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
                ref={phoneRef}
                id="outlined-number"
                label="Номер телефона"
                type="tel"
                placeholder="Введите номер телефона"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </label>
            <label className='w-full sm:w-[400px]'>
              <StyledTextarea ref={messageRef} style={{ "inlineSize": "100%", "background": "transparent", 'color': "white" }} className='w-full' minRows={5} aria-label="empty textarea" placeholder="Сообщение" />
            </label>
            <button className='sm:w-[400px] py-[10px] text-[#00C9DB] border-2 border-[#00C9DB] hover:bg-[#00C9DB] hover:text-white hover:border-white rounded-[15px] duration-200 buttons text-center font-semibold'>ОТПРАВИТЬ</button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact